export class NotesImporter {
    constructor(data) {
        this.notes = {};
        this.separatorIds = [];
        this.data = data;
    }
}
